import React from 'react';
import { usePaymentReview } from 'Hooks/usePaymentReview';
import './PaymentTotalDue.css';

export const PaymentTotalDue = () => {
  const review = usePaymentReview();

  return (
    <div className="paymentTotalDue">
      <span className="reviewLabel">{review.totalLabel}</span>
      <span className="reviewValue">${review.totalPrice}</span>
    </div>
  );
};
